<template>
  <div class="page page-mask page-mask-last">
    <svg v-if="!isIE11" class="page-mask--back" viewBox="0 0 595.391 81.16" enable-background="new 0 0 595.391 81.16">
    <polygon fill="#FFFFFF" points="0,0 0,42.029 595.391,81.16 595.28,0 "/>
    </svg>
    <img v-else class="page-mask--back" src="/static/masks/mask-4.png"/>

  </div>
</template>

<script>
import IEDetector from '@/mixins/IEDetector';

export default {
  mixins: [IEDetector],
};
</script>

<style>
	.page-mask-last{
    margin-bottom: 0;
		z-index: 10;
	}
</style>


// WEBPACK FOOTER //
// src/components/Masks/Mask4.vue